import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AppLoaderMfeConfigService } from '../services/app-loader-mfe-config.service';

export const appLoaderTitleResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot): Observable<string> => {
  const appLoaderMfeConfigService = inject(AppLoaderMfeConfigService);
  const code = route.paramMap.get('code');

  return appLoaderMfeConfigService.resolveMfeConfig(code).pipe(
    map(mfeConfig => {
      return mfeConfig?.title ?? '';
    })
  );
};
